<template>
  <div class="cp-page-refresh">
    <van-pull-refresh
      v-model="pullLoading"
      @refresh="onPullRefresh"
      :head-height="headHeight"
      :success-text="successMsg"
      loading-text="正在刷新"
    >
      <slot></slot>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: 'cpPageRefresh',
  props: {
    headHeight: {
      type: Number,
      default: 50
    },
    successMsg: {
      type: String,
      default: '刷新成功'
    },
  },
  data () {
    return {
      pullLoading: false, // 下拉刷新 - 加载动画显示
    }
  },
  methods: {
    onPullRefresh () {
      this.$emit('refresh')
    },
    hideFresh () {
      setTimeout(() => {
        this.pullLoading = false
      }, 1500)
    },
  },
}
</script>

<style lang="scss" scoped>
.cp-page-refresh {
  width: 100%;
  height: 100%;
  background-color: transparent;
}
</style>
